var blockquote_default = {
  "fontElementMap": "fEZtk",
  "quote": "R4hnK"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
